import Vue from 'vue';

import Framework7 from '@/js/framework7-custom.js';
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

import '@/css/icons.css';
import '@/css/app.less';

import App from '@/components/App.vue';
import store from '@/store/index.js';
import i18n from '@/js/i18n.js';

import 'webrtc-adapter';
import io from 'socket.io-client';
window.io = io;
import VueEcho from 'vue-echo-laravel';
import { WebRTC } from 'vue-webrtc';

import { WS_BASE_PATH } from '@/js/const/index.js';

Framework7.use(Framework7Vue);
Vue.use(VueEcho, {
  client: io,
  broadcaster: 'socket.io',
  host: WS_BASE_PATH,
  auth: {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('access_token')}`
    }
  }
});

Vue.component(WebRTC.name, WebRTC);

// Filters
Vue.filter('two_digits', (value) => {
  if (value < 0) {
    return '00';
  }
  if (value.toString().length <= 1) {
    return `0${value}`;
  }
  return value;
});

// Init App
export default new Vue({
  el: '#app',
  components: {
    app: App
  },
  store,
  i18n,
  render: (h) => h(App)
});
